import React, { useEffect, useState } from "react";
import { Breadcrumb, Container } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import useSEO from "../hooks/useSEO";
import { MyApi } from "../MyApi";

export default function CmsPage() {
  const { slug } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  // Fetch CMS page data from API
  useEffect(() => {
    const fetchPage = async () => {
      try {
        setLoading(true);
        setError(false);

        const res = await axios.get(MyApi.BASE_URL + MyApi.CMS_PAGE + slug, {
          headers: { Authorization: MyApi.SECRET_KEY },
        });

        if (res.data.status && res.data.data) {
          setData(res.data.data);
        } else {
          setError(true);
        }
      } catch (err) {
        console.error("CMS API Error:", err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [slug]);

  // Set SEO dynamically
  useSEO({
    title: data?.meta_title || data?.pagename || "Maa Pateswari University, Balrampur – Courses, Admissions & Latest Updates",
    description: data?.meta_description || "Explore Maa Pateswari University, Balrampur – Find detailed information about courses, admissions, departments, and latest news & updates from MPUB. Stay informed about academic programs and events at Balrampur's leading university.",
    keywords: data?.meta_tags || "Maa Pateswari University, Balrampur University, MPUB courses, MPUB admissions, Balrampur education, university news, MPUB updates, higher education Balrampur",
    canonical: window.location.href,
    ogImage: data?.top_header_bg_image || "",
  });

  if (loading) return <p className="text-center py-5">Loading...</p>;
  if (error) return <Container className="py-5 text-center"><h1>404 - Page Not Found</h1></Container>;

  return (
    <div>
    <div className="BreadcrumbStyle">
       <Container>
          <h1>{data.pagename || data.pageheading}</h1>
          <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
            <Breadcrumb.Item active>{data.pagename || data.pageheading}</Breadcrumb.Item>
          </Breadcrumb>
        </Container>
    </div>
    <div className="pageStyle">
      <Container>
        
        <div dangerouslySetInnerHTML={{ __html: data.pagecontent }} />
      </Container>
      </div>
    </div>
  );
}
